export const DEFAULT_TARGETS = {
  yearly_total_hours: 200,
  yearly_ojti_percent: 50,
  yearly_sim_percent: 10,
  yearly_zone_occurrences: 24,
  days_between_logs: 90,
};
